/* RECOMMEND ITEMS：手動指定が足りない枠を Shopify純正レコメンドで自動補完 */
(function () {
  function slug(a) {
    try {
      var parts = new URL(a.getAttribute('href'), location.origin).pathname.split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    } catch (e) {
      return '';
    }
  }

  function fill(root) {
    var max = parseInt(root.getAttribute('data-max'), 10) || 3;
    var slider = root.querySelector('[data-slider="recommend"]');
    var list = root.querySelector('.p_list');
    if (!slider || !list) return;

    var current = list.querySelectorAll('.p_list-item:not(.swiper-slide-duplicate)');
    var need = max - current.length;
    if (need <= 0) return;

    var url = root.getAttribute('data-url') +
      '?product_id=' + root.getAttribute('data-product-id') +
      '&limit=10&section_id=recommend-auto';

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var seen = {};
        seen[root.getAttribute('data-product-handle')] = true;
        current.forEach(function (el) {
          var a = el.querySelector('a');
          if (a) seen[slug(a)] = true;
        });

        var picks = [];
        doc.querySelectorAll('[data-recommend-auto-result] .p_list-item').forEach(function (el) {
          if (picks.length >= need) return;
          var a = el.querySelector('a');
          var s = a ? slug(a) : '';
          if (!s || seen[s]) return;
          seen[s] = true;
          picks.push(el);
        });
        if (!picks.length) return;

        // スマホ時のスライダーは一度壊してから、商品を足して作り直す
        var sw = slider.swiper;
        var SwiperClass = sw && !sw.destroyed ? sw.constructor : null;
        if (SwiperClass) sw.destroy(true, true);

        picks.forEach(function (el) {
          list.appendChild(document.importNode(el, true));
        });
        root.style.display = '';

        if (SwiperClass) {
          var mine = new SwiperClass(slider, { loop: true, slidesPerView: 1.5, spaceBetween: 5, centeredSlides: true });
          var mq = window.matchMedia('(min-width: 751px)');
          var onChange = function () {
            if (mq.matches && mine && !mine.destroyed) {
              mine.destroy(true, true);
              mine = null;
            }
          };
          if (mq.addEventListener) mq.addEventListener('change', onChange);
          else if (mq.addListener) mq.addListener(onChange);
        }
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-recommend-auto]').forEach(fill);
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();